import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import CommonHeader from '@/components/CommonHeader.vue';
import BeeInput from '@/components/BeeInput.vue';
import BlankLayout from '@/layouts/BlankLayout.vue';
import AddressService from '@/services/AddressService';
import SpinnerHolder from '@/components/SpinnerHolder.vue';
import Modal from '@/components/Modal.vue';
let Locations = class Locations extends Vue {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.user = this.$store.state.user;
        this.locationRes = this.$store.state.deliveryMenu;
        this.lat = String(this.locationRes.location?.lat);
        this.lng = String(this.locationRes.location?.lng);
        this.modalUpdateOrSelect = false;
        this.idAddress = '';
        this.config = {
            headers: {
                Authorization: this.user.authToken,
            }
        };
        this.addressBook = [];
    }
    addAddress() {
        this.$router.push({ name: 'location', params: {
                lat: this.lat,
                lng: this.lng,
                length: String(this.addressBook.length)
            } });
    }
    async updateOrSelect(idAddress) {
        this.idAddress = idAddress;
        this.modalUpdateOrSelect = true;
    }
    async getAddressBook() {
        this.loading = true;
        const request = await AddressService.getAllAddressBook();
        this.addressBook = request?.data;
    }
    async created() {
        this.loading = true;
        if (this.user.authToken) {
            await this.getAddressBook();
        }
        navigator.geolocation.getCurrentPosition(res => {
            this.lat = String(res.coords.latitude);
            this.lng = String(res.coords.longitude);
        });
        this.loading = false;
    }
    async select() {
        this.loading = true;
        const request = await AddressService.getAddressBookById(this.idAddress);
        if (request) {
            const address = request.data;
            address.defaultAddress = true;
            await AddressService.updateAddressBook(this.idAddress, address);
        }
        this.loading = false;
        this.$router.push('/summary');
    }
    async updateAddress() {
        this.$router.push({ name: 'location', params: {
                idAddress: this.idAddress,
                lat: this.lat,
                lng: this.lng
            } });
    }
    async currentLocation() {
        this.$router.push({ name: 'location', params: {
                lat: this.lat,
                lng: this.lng,
                length: String(this.addressBook.length)
            } });
    }
};
Locations = __decorate([
    Component({
        components: {
            BlankLayout,
            CommonHeader,
            BeeInput,
            SpinnerHolder,
            Modal
        },
    })
], Locations);
export default Locations;
